<script setup lang="ts">
import DesktopBuyerMenu from '@layout/nav-v2/desktop/components/menus/DesktopBuyerMenu.vue';
import DesktopUnqualifiedMenu from '@layout/nav-v2/desktop/components/menus/DesktopUnqualifiedMenu.vue';
import DesktopSellerMenu from '@layout/nav-v2/desktop/components/menus/DesktopSellerMenu.vue';
import { computed, type Component } from 'vue';
import { AccountProfile } from '@enums/accountProfile.ts';
import { useUserProfile } from '@stores/useUserProfile.ts';
import { storeToRefs } from 'pinia';

const { userProfile, currentProfile } = storeToRefs(useUserProfile());

const menu = computed<Component>(() => {
  if (userProfile.value === AccountProfile.UNQUALIFIED) {
    return DesktopUnqualifiedMenu;
  }

  if (userProfile.value === AccountProfile.BOTH) {
    return currentProfile.value === AccountProfile.SELLER ? DesktopSellerMenu : DesktopBuyerMenu;
  }

  if (userProfile.value === AccountProfile.SELLER) {
    return DesktopSellerMenu;
  }

  return DesktopBuyerMenu;
});
</script>

<template>
  <component :is="menu" />
</template>
